import _ from "lodash";
import { uploadMediaToCreative, uploadMediaToMeta } from "../../api/Api";
import { v4 } from "uuid";

const containsMedia = (component) => {
    return component.type === 'header' && (component.format !== 'text' || component.format !== 'location');
};

const MetaHeaderMediaUploader = async ({ component, phone, setOpenBackdrop, setBackDropMessage, logToSnackBar }) => {
    if (component.uploaded_file) {
        const formData = new FormData();
        formData.append('businessPhoneNumber', phone);
        formData.append('file', component.uploaded_file);
        setBackDropMessage('Uploading media to meta...')
        setOpenBackdrop(true);
        await uploadMediaToMeta(formData).then(res => {
            logToSnackBar({ message: 'Created media handle in meta', level: 'success' });
            if (!component.example) {
                component['example'] = {};
            }
            component.example._headerHandle = res.h;
            delete component.example.header_handle;
            setOpenBackdrop(false);
        }).catch(error => {
            setOpenBackdrop(false);
            logToSnackBar({ message: `Error while uploading media to meta, ${error?.message}`, level: 'error' });
        });
    }
}

const HeaderMediaUploader = async ({ component, phone, setOpenBackdrop, setBackDropMessage, logToSnackBar }) => {
    if (component.uploaded_file) {
        const formData = new FormData();
        const creative = {
            name: component.uploaded_file.name,
            mediaType: component.uploaded_file.type,
            size: component.uploaded_file.size,
            path: `templates/${v4()}`,
            owningObjectType: 'WHATSAPP',
        };
        const blob = new Blob([JSON.stringify(creative)], { type: 'application/json' });
        formData.append('creative', blob, "creative.json");
        formData.append('file', component.uploaded_file);
        setBackDropMessage('Uploading media to creatives...')
        setOpenBackdrop(true);
        await uploadMediaToCreative(formData).then(res => {
            component.creativeId = res.id;
            logToSnackBar({ message: 'Created creative', level: 'success' });
            setOpenBackdrop(false);
        }).catch(error => {
            setOpenBackdrop(false);
            logToSnackBar({ message: `Error while uploading media to creative, ${error?.message}`, level: 'error' });
        });
    }
}

const MetaUploadHandler = {
    'header': MetaHeaderMediaUploader,
    'carousel': '',
};

const UploadHandler = {
    'header': HeaderMediaUploader,
    'carousel': '',
};

export const uploadCreativesToMeta = async ({ template, phone, setOpenBackdrop, setBackDropMessage, logToSnackBar }) => {
    if (_.isEmpty(template) || _.isEmpty(template.components) || !template.components.some(e => containsMedia(e))) {
        return;
    }
    await Promise.all(template.components.filter(e => containsMedia(e)).map(async (e) => {
        const uploadHandler = MetaUploadHandler[e.type];
        await uploadHandler({ component: e, phone, setOpenBackdrop, setBackDropMessage, logToSnackBar });
    }));
};

export const uploadCreatives = async ({ template, phone, setOpenBackdrop, setBackDropMessage, logToSnackBar }) => {
    if (_.isEmpty(template) || _.isEmpty(template.components) || !template.components.some(e => containsMedia(e))) {
        return;
    }
    await Promise.all(template.components.filter(e => containsMedia(e)).map(async (e) => {
        const uploadHandler = UploadHandler[e.type];
        await uploadHandler({ component: e, phone, setOpenBackdrop, setBackDropMessage, logToSnackBar });
    }));
};

